import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import rootReducer from './ducks';

import { DragDropContextProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

import Notifier from './components/Notifier';
import PrivateRoute from './utils/PrivateRoute';
import IndexPage from './pages/index/IndexPage';
import LoginPage from './pages/login/LoginPage';
import TransfersPage from './pages/transfers/TransfersPage';

const createStoreWithMiddleware = applyMiddleware(
  promiseMiddleware(),
  thunk,
)(createStore);
const store = createStoreWithMiddleware(rootReducer);

const theme = createMuiTheme({
  // palette: {
  // 	type: 'dark'
  // },
  typography: {
    useNextVariants: true,
  },
});

class App extends Component {
  render() {
    return (
      <DragDropContextProvider backend={HTML5Backend}>
        <Provider store={store}>
          <MuiThemeProvider theme={theme}>
            <Router basename={process.env.PUBLIC_URL}>
              <div>
                <CssBaseline />
                <Notifier />
                <Route exact path="/" component={IndexPage} />
                <Route path="/login" component={LoginPage} />
                <PrivateRoute path="/transfers" component={TransfersPage} />
              </div>
            </Router>
          </MuiThemeProvider>
        </Provider>
      </DragDropContextProvider>
    );
  }
}

export default App;
